import { Button, Flex } from 'antd';
import styled from 'styled-components';

interface MobileFullPageStyledProps {
  $isOpen: boolean;
}

export const MobileFullPageStyled = styled(Flex).attrs({
  vertical: true,
})<MobileFullPageStyledProps>`
  position: fixed;
  left: 0;
  z-index: 1000;
  top: var(--header-height);
  max-height: calc(100vh - var(--header-height));
  height: 100%;
  background: ${({ theme }) => theme.colorBgLayout};
  min-width: 100dvw;
  margin: 0 !important;
  display: ${({ $isOpen }) => ($isOpen ? 'flex' : 'none')};
`;

export const LinkButton = styled(Button)`
  color: ${({ theme }) => theme.colorPrimary};
`;

export const HeaderTitleWrapper = styled(Flex).attrs({
  align: 'baseline',
  justify: 'center',
})`
  padding-top: 16px;
`;
